import { useSearchParams } from 'react-router-dom';

export const useRedirectUrl = () => {
  const [params] = useSearchParams();
  return params.get('redirectUrl') || '';
};
